<template>
  <div class="otodetlawadv">
    <div class="bgcover">
      <img src="../../../assets/home/lvshi_lv_sample1.png" alt="" />
    </div>
    <div class="advtxt">
      <div class="advlawname">花文静·律师</div>
      <div class="advlawlabel">刑事辩护、房产纠纷</div>
      <div class="advdh">181-3118-6866</div>
      <div class="advbtn">咨询我</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.otodetlawadv {
  position: relative;
  overflow: hidden;
  .bgcover {
    img {
      width: 166px;
      height: 160px;
      object-fit: cover;
    }
  }
  .advtxt {
    width: 100%;
    height: 110px;
    text-align: center;
    padding: 18px;
    background-color: #fff;
    .advlawname {
      font-size: 16px;
      color: #333;
    }
    .advlawlabel {
      margin-top: 5px;
      font-size: 14px;
      color: #333;
    }
    .advdh {
      margin-top: 5px;
      color: #0465ea;
      font-size: 14px;
    }
    .advbtn {
      display: none;
      width: 80px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin: 5px auto 0;
      background: #0465ea;
      border-radius: 30px;
      font-size: 14px;
      color: #ffffff;
    }
  }
  &:hover {
    .advtxt {
      .advdh {
        display: none;
      }
      .advbtn {
        display: block;
      }
    }
  }
}
</style>